<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-btn
        absolute
        style="right: 0"
        class="mt-1"
        icon
        @click="dialog = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-title>{{ $t("edit") }}</v-card-title>
      <div class="d-flex">
        <v-card-text>
          <div class="d-flex">
            <v-list-item-title class="mb-2">{{
              $t("ourOrders")
            }}</v-list-item-title>
            <v-list-item-title>Рекомендация ОЗЛ</v-list-item-title>
          </div>
          <div class="d-flex mx-n2">
            <div class="px-2 flex-grow-1">
              <v-sheet color="primary" dark class="rounded pa-2 mb-2">
                {{ $t("product") }}: {{ requestItemData.productName }}
                <p class="mb-0 text-decoration-line-through">
                  {{ requestItemData.oldProductName }}
                </p>
              </v-sheet>
            </div>
            <div
              class="px-2"
              v-show="
                requestItemData.productId !== requestItemData.offerProductId
              "
            >
              <v-btn
                height="35"
                v-if="requestItemData.offerProductId"
                class="mr-2"
                color="secondary"
                x-small
                @click="selectProduct"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 792.082 792.082"
                >
                  <path
                    d="M317.896,396.024l304.749-276.467c27.36-27.36,27.36-71.677,0-99.037s-71.677-27.36-99.036,0L169.11,342.161
				c-14.783,14.783-21.302,34.538-20.084,53.897c-1.218,19.359,5.301,39.114,20.084,53.897l354.531,321.606
				c27.36,27.36,71.677,27.36,99.037,0s27.36-71.677,0-99.036L317.896,396.024z"
                  />
                </svg>
              </v-btn>
            </div>
            <div class="px-2 flex-grow-1">
              <v-sheet color="primary" dark class="rounded pa-2 mb-2">
                {{ requestItemData.offerProductName }}
              </v-sheet>
            </div>
          </div>
          <div class="d-flex mx-n2">
            <div class="px-2 flex-grow-1">
              <v-sheet color="primary" dark class="rounded pa-2 mb-2">
                {{ $t("measureShort") }}: {{ requestItemData.unit_type_name }}
                <p class="mb-0 text-decoration-line-through">
                  {{ requestItemData.old_unit_type_name }}
                </p>
              </v-sheet>
            </div>
            <div class="px-2">
              <v-btn
                height="35"
                v-if="
                  requestItemData.offerUnitTypeId !== requestItemData.unitTypeId
                "
                class="mr-2"
                color="secondary"
                x-small
                @click="selectUnitType"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 792.082 792.082"
                >
                  <path
                    d="M317.896,396.024l304.749-276.467c27.36-27.36,27.36-71.677,0-99.037s-71.677-27.36-99.036,0L169.11,342.161
				c-14.783,14.783-21.302,34.538-20.084,53.897c-1.218,19.359,5.301,39.114,20.084,53.897l354.531,321.606
				c27.36,27.36,71.677,27.36,99.037,0s27.36-71.677,0-99.036L317.896,396.024z"
                  />
                </svg>
              </v-btn>
            </div>
            <div class="px-2 flex-grow-1">
              <v-sheet color="primary" dark class="rounded pa-2 mb-2">
                {{ requestItemData.offer_unit_type_name }}
              </v-sheet>
            </div>
          </div>
          <div class="d-flex mx-n2">
            <div class="px-2 flex-grow-1">
              <v-sheet color="primary" dark class="rounded pa-2">
                {{ $t("count") }}: {{ requestItemData.count }}
                <p class="mb-0 text-decoration-line-through">
                  {{ requestItemData.oldCount }}
                </p>
              </v-sheet>
            </div>
            <div class="px-2">
              <v-btn
                height="35"
                v-if="requestItemData.count !== requestItemData.offerCount"
                class="mr-2"
                color="secondary"
                x-small
                @click="selectCount"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 792.082 792.082"
                >
                  <path
                    d="M317.896,396.024l304.749-276.467c27.36-27.36,27.36-71.677,0-99.037s-71.677-27.36-99.036,0L169.11,342.161
				c-14.783,14.783-21.302,34.538-20.084,53.897c-1.218,19.359,5.301,39.114,20.084,53.897l354.531,321.606
				c27.36,27.36,71.677,27.36,99.037,0s27.36-71.677,0-99.036L317.896,396.024z"
                  />
                </svg>
              </v-btn>
            </div>
            <div class="px-2 flex-grow-1">
              <v-sheet color="primary" dark class="rounded pa-2">
                {{ requestItemData.offerCount }}
              </v-sheet>
            </div>
          </div>
          <div class="mt-2">
            <h3 style="color: dimgrey">{{ $t("comment") }}</h3>
            <v-alert dense outlined color="primary" class="mt-2">
              {{ requestItemData.offerComment }}
            </v-alert>
          </div>
          <div
            class="px-2 d-flex align-center flex-grow-1 mx-n2 mt-2"
            v-if="requestItemData.offerFileName"
          >
            <downloader
              :address="requestItemData.offerFileName"
              :file-name="requestItemData.offerFileOriginalName"
            />
            <h4>{{ $t("file") }}</h4>
          </div>
        </v-card-text>
      </div>
      <div class="text-right pa-4">
        <v-btn :loading="loading" color="primary" @click="save">{{
          $t("send")
        }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { getValueByKey } from "@/utils/pureFunctions";
import Downloader from "@/components/ui/downloader";

const defaultRequestItemData = {
  id: null,
  offerUnitTypeId: null,
  unitTypeId: null,
  offer_unit_type_name: null,
  unit_type_name: null,
  old_unit_type_name: null,
  offerProductId: null,
  productId: null,
  productName: null,
  offerProductName: null,
  oldProductName: null,
  offerCount: null,
  count: null,
  oldCount: null,

  offerFileName: null,
  offerFileOriginalName: null,
  offerComment: null,
};
export default {
  name: "changeRequestOrderItemDialog",
  components: { Downloader },
  data() {
    return {
      loading: false,
      dialog: false,
      requestItemData: { ...defaultRequestItemData },
    };
  },
  methods: {
    clear() {
      this.requestItemData = { ...defaultRequestItemData };
      this.dialog = false;
    },
    open(data) {
      this.dialog = true;
      this.requestItemData = {
        ...getValueByKey(defaultRequestItemData, data),
        offer_unit_type_name: data[`offer_unit_type_name_${this.$i18n.locale}`],
        unit_type_name: data[`unit_type_name_${this.$i18n.locale}`],
      };
    },
    selectProduct() {
      const { offerProductName, offerProductId, productName } =
        this.requestItemData;
      this.requestItemData = {
        ...this.requestItemData,
        productId: offerProductId,
        productName: offerProductName,
        oldProductName: productName,
      };
    },
    selectUnitType() {
      const { offerUnitTypeId, unit_type_name } = this.requestItemData;
      this.requestItemData = {
        ...this.requestItemData,
        unitTypeId: offerUnitTypeId,
        unit_type_name: this.requestItemData.offer_unit_type_name,
        old_unit_type_name: unit_type_name,
      };
    },
    selectCount() {
      const { count, offerCount } = this.requestItemData;
      this.requestItemData = {
        ...this.requestItemData,
        count: offerCount,
        oldCount: count,
      };
    },
    async save() {
      try {
        const {
          unitTypeId,
          productId: product_id,
          count,
          id,
        } = this.requestItemData;
        this.loading = true;
        await this.$http.post("orders/update-ozl-offer", {
          unitTypeId,
          product_id,
          count,
          id,
        });
        this.setSuccess({ text: this.$t("successfullySent") });
        this.$emit("saved");
        this.clear();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
